import React from 'react'
import styled from 'styled-components'
import ReactToPrint from 'react-to-print'

import LinkButton from '../../../components/LinkButton'
import breakpoints from '../../../constants/breakpoints'
import i18n from '../../../i18n'
import { PrintHeader } from '../../../types'
import Readspeaker from '../../../components/Readspeaker'
import { ModalConsumer } from '../../../context/ModalContext'

interface Props {
  overviewRef: HTMLDivElement | null | undefined
  text: PrintHeader | null
}

const Header: React.FC<Props> = ({ overviewRef, text }) => {
  const scrollToOverview = () => {
    if (overviewRef) {
      overviewRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <HeaderContainer>
      <Content>
        <Subtitle>
          {text && text.subtitle ? text.subtitle : i18n.t('overview.header.subtitle')}
        </Subtitle>
        <h1>{text && text.title ? text.title : i18n.t('overview.header.title')}</h1>
        <Readspeaker />
        <Description
          dangerouslySetInnerHTML={{
            __html:
              text && text.description ? text.description : i18n.t('overview.header.description'),
          }}
        />
        {text?.info && (
          <ModalLinkWrapper>
            {text?.info.map((item, index) => (
              <ModalConsumer key={index}>
                {({ openModal }) => (
                  <StyledLink
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      openModal(item.title, item.content)
                    }}
                  >
                    {item.urlText ? item.urlText : i18n.t('explanation.moreInfo')}
                  </StyledLink>
                )}
              </ModalConsumer>
            ))}
          </ModalLinkWrapper>
        )}
        <Next>
          <ReactToPrint
            trigger={() => <LinkButton>{i18n.t('overview.header.printButton')}</LinkButton>}
            content={() => overviewRef || document.createElement('<span>')}
          />

          <LinkButton onClick={scrollToOverview} tertiary>
            {i18n.t('overview.header.viewButton')}
          </LinkButton>
        </Next>
      </Content>
    </HeaderContainer>
  )
}

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  padding: 0 30px;
`

const Content = styled.div`
  padding: 0 0 80px;
  margin-top: 64px;

  @media (min-width: ${breakpoints.md}) {
    max-width: 550px;
  }
`

const Subtitle = styled.span`
  font-size: 1rem;
  font-weight: bold;
`

const Description = styled.div`
  margin: 0 0 35px;
  text-align: left;
`

const ModalLinkWrapper = styled.div`
  margin: 0 0 35px;
  display: flex;
  flex-direction: column;
  align-items: start;

  > a {
    width: auto;
  }
`

const StyledLink = styled.a`
  color: ${({ theme }) => theme.blue};
  text-decoration: underline;
  display: block;
  width: fit-content;
`

const Next = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: auto;

  & > a,
  & > button {
    margin: 8px 0;
    width: auto;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    width: 100%;

    & > button {
      margin: 8px;
      width: 100%;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
`
export default Header
